import * as i0 from "@angular/core";
var FormDataService = /** @class */ (function () {
    function FormDataService() {
    }
    FormDataService.prototype.createFormData = function (object, form, namespace) {
        var _this = this;
        var formData = form || new FormData();
        var _loop_1 = function (property) {
            if (!object.hasOwnProperty(property) || !object[property] || object[property] === undefined) {
                return "continue";
            }
            var formKey = namespace ? namespace + "." + property : property;
            if (object[property] instanceof Date) {
                formData.append(formKey, object[property].toISOString());
            }
            else if (Array.isArray(object[property])) {
                object[property].forEach(function (element, index) {
                    var tempFormKey = formKey + "[" + index + "]";
                    if (typeof element === 'object' && !(element instanceof File)) {
                        _this.createFormData(element, formData, tempFormKey);
                    }
                    else {
                        formData.append(tempFormKey, element);
                    }
                });
            }
            else if (typeof object[property] === 'object' && !(object[property] instanceof File)) {
                this_1.createFormData(object[property], formData, formKey);
            }
            else {
                formData.append(formKey, object[property]);
            }
        };
        var this_1 = this;
        for (var property in object) {
            _loop_1(property);
        }
        return formData;
    };
    FormDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormDataService_Factory() { return new FormDataService(); }, token: FormDataService, providedIn: "root" });
    return FormDataService;
}());
export { FormDataService };
